import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f9420d2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tilte" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "订单号", -1))
const _hoisted_3 = {
  key: 0,
  class: "button-line van-hairline--top nongfu-button-wrap"
}
const _hoisted_4 = {
  key: 0,
  class: "button-tips"
}

import { useRouter } from 'vue-router'
import { List, PullRefresh, Button } from 'vant'
import { getThousandMoney } from '@/utils/index'
import { getWuyouOrderList } from '@/apis/insurance'
import { XssCommonPageListQuery } from '@/types/public'
import { CacheSelectWuyouOrderInfoKey } from '@/config/insurance'
import useCommonList, { PageParams, PageListResut } from '@/compositions/useCommonList'
import { GetWuyouOrderListItem, WuyouRenderListItemType } from '@/types/insurance'
import AppHeader from '@/components/Header.vue'
import BaseInfoList from '../components/base-info-list.vue'
import InvoiceApplyCheck from '@/components/invoice/invoice-apply-check.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'order-list',
  setup(__props) {

const $router = useRouter()
async function queryList(
  params: PageParams & XssCommonPageListQuery
): Promise<PageListResut<GetWuyouOrderListItem>> {
  try {
    const data = await getWuyouOrderList({
      ...params,
    })
    const result = {
      ...data,
      data: data.data.map((item: GetWuyouOrderListItem) => {
        let orderInfo = [
          {
            label: '订单状态',
            value: item.status_text,
          },
          { label: '订单支付金额', value: `¥ ${getThousandMoney(Number(item.price))}` },
        ]
        if (item.pay_at) {
          orderInfo.push({ label: '订单支付时间', value: item.pay_at })
        }
        if (item.refund) {
          orderInfo = orderInfo.concat([
            {
              label: '已退款金额',
              value: `¥ ${getThousandMoney(Number(item.refund))}`,
            },
            // {
            //   label: '最后退款时间',
            //   value: item.refunded_at,
            // },
          ])
        }
        return {
          ...item,
          orderInfo,
          snInfo: [{ label: `SN:${item.serial_number}(${item.model_name})`, value: '' }],
          showApplyInvoiceButton: item.can_invoice_apply,
        }
      }),
    }
    return result
  } catch (error) {
    console.log('error', error)
    return Promise.reject(error)
  }
}
const {
  refreshing,
  loading,
  requestError,
  finished,
  onRefresh,
  dataList,
  queryHandle,
  finishedText,
} = useCommonList<WuyouRenderListItemType, PageParams>(queryList, {})

function applyInvoice(item: WuyouRenderListItemType) {
  const cacheKey = CacheSelectWuyouOrderInfoKey + item.guid
  sessionStorage.setItem(cacheKey, JSON.stringify(item))
  $router.push({
    name: 'insurance-wuyou-invoice-apply',
    query: {
      cacheKey,
    },
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "无忧计划订单" }),
    _createVNode(_unref(PullRefresh), {
      modelValue: _unref(refreshing),
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(refreshing) ? (refreshing).value = $event : null)),
      onRefresh: _unref(onRefresh),
      class: "list-wrap"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(List), {
          loading: _unref(loading),
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => (_isRef(loading) ? (loading).value = $event : null)),
          error: _unref(requestError),
          "onUpdate:error": _cache[1] || (_cache[1] = ($event: any) => (_isRef(requestError) ? (requestError).value = $event : null)),
          finished: _unref(finished),
          offset: 200,
          "finished-text": _unref(finishedText),
          "error-text": "加载失败",
          onLoad: _unref(queryHandle),
          class: "list-container"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataList), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.serial_number,
                class: "van-hairline--surround list-item"
              }, [
                _createElementVNode("div", _hoisted_1, [
                  _hoisted_2,
                  _createElementVNode("div", null, _toDisplayString(item.number), 1)
                ]),
                _createVNode(BaseInfoList, {
                  list: item.orderInfo,
                  listItemJustifyContent: "space-between",
                  listItemMt: 8,
                  class: "van-hairline--top"
                }, null, 8, ["list"]),
                _createVNode(BaseInfoList, {
                  list: item.snInfo,
                  class: "van-hairline--top",
                  labelWidth: "100%"
                }, null, 8, ["list"]),
                (item.showApplyInvoiceButton)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      (item.showApplyInvoiceButton)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, "*30天内可申请开票！"))
                        : _createCommentVNode("", true),
                      (item.showApplyInvoiceButton)
                        ? (_openBlock(), _createBlock(_unref(Button), {
                            key: 1,
                            block: "",
                            class: "xa-vant-button",
                            type: "success",
                            onClick: ($event: any) => (applyInvoice(item)),
                            round: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("申请发票")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (item.invoice_apply_guid)
                  ? (_openBlock(), _createBlock(InvoiceApplyCheck, {
                      key: 1,
                      guid: item.invoice_apply_guid,
                      time: item.apply_at,
                      orderNo: item.number
                    }, null, 8, ["guid", "time", "orderNo"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["loading", "error", "finished", "finished-text", "onLoad"])
      ]),
      _: 1
    }, 8, ["modelValue", "onRefresh"])
  ], 64))
}
}

})